import type { ValueOf } from '@kc-console/core';
import type { PropsWithClassName } from '../../types';

const SpinnerColorSet = ['default', 'inverse'] as const;
type SpinnerColor = ValueOf<typeof SpinnerColorSet>;

const SpinnerSizeSet = ['xs', 'sm', 'md', 'lg'] as const;
type SpinnerSize = ValueOf<typeof SpinnerSizeSet>;

const SpinnerSizeMap: Record<SpinnerSize, string | number> = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
};

type SpinnerProps = {
  /**
   * Spinner의 색상을 설정합니다.
   * @default default
   */
  color?: SpinnerColor;
  /**
   * Spinner의 크기를 설정합니다.
   * xs: 12 x 12
   * sm: 16 x 16
   * md: 20 x 20
   * lg: 24 x 24
   * @default sm
   */
  size?: SpinnerSize;
} & PropsWithClassName;

export type SpinnerOwnerState = Required<Pick<SpinnerProps, 'color' | 'size'>>;

export type { SpinnerColor, SpinnerSize, SpinnerProps };

export { SpinnerColorSet, SpinnerSizeMap, SpinnerSizeSet };
